// --- Collection query/mutation key definitions ---

export const COLLECTION_KEYS = {
  quantities: () => ['collectionQuantities'] as const,
  quantitiesByBase: () => ['collectionQuantitiesByBase'] as const,
}

export const COLLECTION_MUTATION_KEYS = {
  add: ['mutation', 'collection', 'add'] as const,
  update: ['mutation', 'collection', 'update'] as const,
  updateByCard: ['mutation', 'collection', 'updateByCard'] as const,
  remove: ['mutation', 'collection', 'remove'] as const,
  removeByCard: ['mutation', 'collection', 'removeByCard'] as const,
}

// All collection mutations share one replay scope so queued offline changes
// replay strictly in the order the user made them (TanStack serializes
// same-scope mutations; everything else replays in parallel).
export const COLLECTION_SCOPE = { id: 'collection' } as const

// Keys reconciled when a collection write settles. Used by the runtime hooks
// below AND by the replay defaults registered in main.tsx (a replayed-after-
// reload mutation has no hook callbacks, only these). `userQuantities`
// reseeds the optimistic quantity maps via setQueryData; `buylist` reflects
// rows drained by adds (#101); `collectionQuantitiesByBase` drives the
// cross-variant "(N)" badges and deck "Missing N cards" counts.
export const COLLECTION_WRITE_SETTLED_KEYS = [
  ['userQuantities'],
  ['dashboardStats'],
  ['collectionItemByCard'],
  ['buylist'],
  ['collectionQuantitiesByBase'],
] as const

export const COLLECTION_REMOVE_SETTLED_KEYS = [
  ['userQuantities'],
  ['dashboardStats'],
  ['collectionItemByCard'],
  ['collectionQuantitiesByBase'],
] as const

// --- Sealed collection query/mutation key definitions ---

export const SEALED_COLLECTION_KEYS = {
  quantities: () => ['sealedCollectionQuantities'] as const,
}

export const SEALED_MUTATION_KEYS = {
  add: ['mutation', 'sealedCollection', 'add'] as const,
  update: ['mutation', 'sealedCollection', 'update'] as const,
  remove: ['mutation', 'sealedCollection', 'remove'] as const,
}

// All sealed-collection writes share one replay scope so queued offline
// changes replay in order (see COLLECTION_SCOPE for the rationale).
export const SEALED_SCOPE = { id: 'sealedCollection' } as const

// Mirrors INVALIDATION_GROUPS.sealedCollection — the keys a sealed write
// reconciles on settle. Used by the runtime hooks AND the replay defaults in
// main.tsx (a replayed-after-reload mutation has only these, no hook callbacks).
export const SEALED_SETTLED_KEYS = [['userQuantities'], ['dashboardStats'], ['sealedCollection']] as const
